import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { FormSubmissionInput } from '@qdf/shared';

interface ConsentSectionProps {
  register: UseFormRegister<FormSubmissionInput>;
  errors: FieldErrors<FormSubmissionInput>;
}

export function ConsentSection({ register, errors }: ConsentSectionProps) {
  return (
    <fieldset>
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            className="mt-1 h-4 w-4 rounded border-gray-300 text-brand-500
              focus:ring-brand-500/20"
            {...register('consentGiven')}
          />
          <span className="text-sm text-gray-700">
            I consent to receive electronic communications regarding my account status. I certify
            that the information provided is accurate to the best of my knowledge and authorize
            Quick Draw Funding to process this application.
          </span>
        </label>
        {errors.consentGiven?.message && (
          <p className="mt-2 text-xs text-error-500 ml-7">{errors.consentGiven.message}</p>
        )}
      </div>
    </fieldset>
  );
}
